export default "__VITE_ASSET__8862182b__"